import { render, staticRenderFns } from "./achievement.vue?vue&type=template&id=a1ca0424&scoped=true&"
import script from "./achievement.vue?vue&type=script&lang=js&"
export * from "./achievement.vue?vue&type=script&lang=js&"
import style0 from "./achievement.vue?vue&type=style&index=0&id=a1ca0424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ca0424",
  null
  
)

export default component.exports